<template>
  <div class="w-full h-full">
    <div class="w-3/4 m-auto font-medium text-2xl pb-3 document-page-title">
      {{ $t("message.main_bussines_page.business.title_bussines") }}
    </div>
    <div class="flex w-3/4 m-auto main-porlet">
      <div
        v-for="(card, index) in filterMainMenu"
        :key="index"
        @click="redirectToCard(card.href, card.hasBaseRouter)"
        class="bg-white flex round items-center w-2/5 mr-4 shadow-md hover:shadow-lg cursor-pointer porlet"
      >
        <div class="w-2/2 p-4">
          <component :is="card.img"></component>
        </div>
        <div class="w-11/12 pl-2 pr-4">
          <p class="font-medium text-xl mb-3 text-zt-dark-600 porlet-title">
            {{ $t(`message.main_bussines_page.business.${card.title}`) }}
          </p>
          <span class="text-zt-dark-300">
            {{ $t(`message.main_bussines_page.business.${card.subtitle}`) }}
          </span>
        </div>
      </div>
    </div>
    <div v-for="(section, index) in filterSecondMenu" :key="index">
      <div class="w-3/4 m-auto font-medium text-xl pb-3 document-page-title" v-if="section.cardsItem.length >= 1">
        {{ $t(`message.main_bussines_page.${section.sectionTitle}`) }}
      </div>
      <div class="flex w-3/4 m-auto secondaryPorlet">
        <div
          v-for="(card, index) in section.cardsItem"
          :key="index"
          @click="redirectToCard(card.href, card.hasBaseRouter)"
          class="flex rounded-tl-lg w-1/3 mr-4 p-4 bg-white shadow-md hover:shadow-lg items-center cursor-pointer porlet"
        >
          <div class="w-1/12 porlet-icon flex self-start mt-2 mr-4 pt-1">
            <zt-icon v-if="card.icon" :name="card.icon" class="text-zt-xl" />
            <component v-else :is="card.iconSvg"></component>
          </div>
          <div class="w-11/12">
            <h1 class="font-medium text-xl mb-3 text-zt-dark-600 porlet-title">
              {{ $t(`message.main_bussines_page.${card.title}`) }}
            </h1>
            <span class="text-zt-dark-300 w-4/4 block">
              {{ $t(`message.main_bussines_page.${card.subtitle}`) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FolderSettingsLogoSVG from "../views/SVG/FolderSettingsSVG";
import OnboardingLogoSVG from "../views/SVG/OnboardingSVG";
import BankIconSVG from "../views/SVG/BankIconSVG";
import ColorIconSvg from "../views/SVG/ColorIconSVG";
import CertIconSVG from "../views/SVG/CertIconSVG";
import { isEmpty } from "underscore";
import { mapGetters } from 'vuex'

export default {
  name: "MainBusinessPage",
  components: {
    FolderSettingsLogoSVG,
    OnboardingLogoSVG,
    BankIconSVG,
    ColorIconSvg,
    CertIconSVG,
  },
  data() {
    return {
      mainCards: [
        {
          img: "FolderSettingsLogoSVG",
          title: "folder_settings",
          subtitle: "subtitle_folder_settings",
          action: 82,
          href: "folder",
          hasBaseRouter: true,
        },
        {
          img: "OnboardingLogoSVG",
          title: "news_billboard",
          subtitle: "subtitle_news_billboard",
          action: 44,
          href: `${window.origin}/v3/news-board`,
          hasBaseRouter: false,
        },
      ],
      secondCards: [
        {
          sectionTitle: "notifications.title_notifications",
          cardsItem: [
            {
              title: "notifications.welcome_email",
              subtitle: "notifications.subtitle_welcome_email",
              action: 110,
              icon: "envelop",
              href: "/company/welcome-email",
              hasBaseRouter: true,
            },
            {
              title: "notifications.Personalize_emails",
              subtitle: "notifications.subtitle_Personalize_emails",
              action: 109,
              icon: "envelop",
              href: "/CustomEmails",
              hasBaseRouter: true,
            },
          ],
        },
        {
          sectionTitle: "personalization.title_personalization",
          cardsItem: [
            {
              title: "personalization.brand_update",
              subtitle: "personalization.subtitle_brand_update",
              action: 109,
              icon: "image",
              href: "/update/logo",
              hasBaseRouter: true,
            },
            {
              title: "personalization.color_palette",
              subtitle: "personalization.subtitle_color_palette",
              action: 109,
              iconSvg: "ColorIconSvg",
              href: "/update/colors",
              hasBaseRouter: true,
            },
          ],
        },
        {
          sectionTitle: "workflow.title_workflow",
          cardsItem: [
            {
              title: 'workflow.workflow_creation',
              subtitle: 'workflow.subtitle_workflow_creation',
              action: 301,
              icon: 'sync',
              href: 'workflow',
              hasBaseRouter: true
            },
            {
              title: 'workflow.group_management',
              subtitle: 'workflow.subtitle_group_management',
              action: -1,
              icon: 'person',
              hasBaseRouter: true
            }
          ]
        },

        {
          sectionTitle: "onboarding.title_onboarding",
          cardsItem: [
            {
              title: "onboarding.onboarding_settings",
              subtitle: "onboarding.subtitle_onboarding_settings",
              action: 73,
              icon: "sync",
              href: "onboarding/list",
              hasBaseRouter: true,
            },
          ],
        },
        {
          sectionTitle: "self_service.title_self_service",
          cardsItem: [
            {
              title: "self_service.data_update",
              subtitle: "self_service.subtitle_data_update",
              action: 200,
              icon: "paperclip-2",
              href: 'self-service',
              hasBaseRouter: true,
            },
            {
              title: "self_service.bank_data",
              subtitle: "self_service.subtitle_bank_data",
              action: -1,
              iconSvg: "BankIconSVG",
              hasBaseRouter: true,
            },
          ],
        },
        {
          sectionTitle: "certificate.title_certificate",
          cardsItem: [
            {
              title: "certificate.electronic_sign_cert",
              subtitle: "certificate.subtitle_electronic_sign_cert",
              action: 104,
              iconSvg: "CertIconSVG",
              href: "certificates",
              hasBaseRouter: true,
            },
          ],
        },

        {
          sectionTitle: "other_settings.title_other_settings",
          cardsItem: [
            {
              title: "other_settings.audit",
              subtitle: "other_settings.subtitle_audit",
              action: 30,
              icon: "eye",
              href: "/v3/audit/viewer",
              hasBaseRouter: false,
            },
            {
              title: "other_settings.security_Center",
              subtitle: "other_settings.subtitle_security_center",
              action: 86,
              icon: "shield-check-outline",
              href: "generalSettings",
              hasBaseRouter: true,
            },
            {
              title: "other_settings.manager_management",
              subtitle: "other_settings.subtitle_manager_management",
              icon: "person",
              href: "/manager/management",
              hasBaseRouter: true,
              company_has_manager_profile: this.$store.state.profile.company_has_manager_profile
            }
          ],
        },
        {
          sectionTitle: "payroll.title",
          cardsItem: [
            {
              title: "payroll.payrollConfig",
              subtitle: "payroll.description",
              action: 'payroll',
              icon: "envelop",
              href: "/company/payroll-config",
              hasBaseRouter: true,
            },
          ],
        },
      ],
    };
  },
  methods: {
    billboardProfileCheck(item) {
      if (!isEmpty(this.$store.state.profile)) {
        const isBillboardProfile = this.$store.state.profile.perfiles.some(
          (perfil) => perfil.nombre.includes("CARTELERA")
        )
        if (isBillboardProfile && item.action === 'payroll') {
          return false
        }
        if (isBillboardProfile && (item.company_has_manager_profile !== undefined || item.action === 301)) {
          return false
        }
      }
      return true
    },
    performanceIntegrationCheck(item) {
      if (this.getHasPerformanceIntegration && (item.action === 44 || item.action === 110 || item.action === 109 || item.action === 200 || item.action === 30 || item.action === 86 || item.action === 'payroll')) {
        return true
      }
      return false
    },
    filterActionsMenu(item) {
      if (!this.$store.state.permissions) return false;
      if (this.$store.state.permissions.length > 0) {
        if (!this.billboardProfileCheck(item)) return false;
        if (this.performanceIntegrationCheck(item)) return false;
        if (item.action === 110 && localStorage.getItem('welcome') === 'sended') return false
        return this.$store.state.permissions.includes(item.action);
      }
      return false;
    },

    filterWithoutActionMenu(item) {
      return item.company_has_manager_profile;
    },
    redirectToCard(href, baseRouter) {
      !baseRouter ? (window.location.href = href) : this.$router.push(href);
    },
  },
  computed: {
    filterMainMenu() {
      return this.mainCards.filter(this.filterActionsMenu);
    },

    ...mapGetters(['getHasPerformanceIntegration']),

    filterSecondMenu() {
      const newFilterMenu = [];
      for (let i of this.secondCards) {
        const objNewMenu = {};
        const cardsItem = i.cardsItem.filter(this.filterActionsMenu);
        const withoutActionCards = i.cardsItem.filter(
          this.filterWithoutActionMenu
        ).filter(this.billboardProfileCheck);
        const allCardsItem = cardsItem.concat(withoutActionCards);
        if (allCardsItem.length > 0) {
          (objNewMenu.sectionTitle = i.sectionTitle),
          (objNewMenu.cardsItem = allCardsItem);
        }
        if (Object.keys(objNewMenu).length > 0) newFilterMenu.push(objNewMenu);
      }
      return newFilterMenu;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./public/assets/scss/_config.scss";

.document-page-title {
  color: #707070;
}

.porlet {
  border-radius: 5px;
}
.porlet:hover {
  .porlet-title {
    color: $blue-primary;
  }

  .porlet-icon {
    color: $blue-primary;
    fill: $blue-primary;
  }
}

.porlet-icon {
  color: #0a0a0a;
}

.main-porlet {
  height: 233px;
  margin-bottom: 2% !important;
}

.secondaryPorlet {
  height: 140px;
  margin-bottom: 2% !important;
}
svg:hover {
  fill: red;
}
</style>